<template>
  <div class="p-gototop" :class="{ uWhite: $route.name==='kodateDetail' || $route.name==='MemberLogin' }">
    <button @click="clickSmoothScroll">ページTOPへ</button>
  </div>
</template>

<script>
export default {
  name: 'CommonGoToTop',
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    clickSmoothScroll() {
      this.$SmoothScroll(
        document.querySelector('body'),
        400,
        null,
        null,
        'y',
      );
      if (this.$route.name === 'KodatePrefecture' || this.$route.name === 'FavoriteNew' || this.$route.name === 'KodateCity' || this.$route.name === 'KodateTown') {
        document.querySelector('.js-search-list').scrollTo({
          top,
          behavior: 'smooth',
        });
      }
    },
  },
};
</script>
<style lang='scss' scoped>
@charset 'UTF-8';
.p-gototop{
  width: 100%;
  padding: 30px 0;
  background-color: #FAFAFA;
  button {
    width: 220px;
    height: 40px;
    margin: auto;
    border: 1px solid #707070;
    border-radius: 20px;
    display:flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: #FFF;
  }
  button:after {
    content: '';
    background-image: url('/static/img/icon-arrow.png');
    background-size: cover;
    transform:rotateZ(270deg);
    position: absolute;
    width: 18px;
    height: 18px;
    top:10px;
    right:40px;
  }
}

.uWhite {
  background-color: #FFF;
}
</style>
